import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

// Works natively in both Vercel Serverless (/api/graphql) and Express Server
const uri = '/api/graphql';

const httpLink = createHttpLink({ uri });

function buildHydrateHeader() {
  try {
    const rawUser = localStorage.getItem('sa_user_cache');
    const rawProducts = localStorage.getItem('sa_products_cache');
    if (!rawUser && !rawProducts) return '';

    const user = rawUser ? JSON.parse(rawUser) : null;
    let products = rawProducts ? JSON.parse(rawProducts) : [];

    // Strip large inline base64 images from HTTP header payload to avoid 8KB header limit
    if (Array.isArray(products)) {
      products = products.map(p => ({
        id: p.id,
        supplierId: p.supplierId,
        name: p.name,
        category: p.category,
        description: p.description ? p.description.slice(0, 300) : '',
        priceRange: p.priceRange,
        moq: p.moq,
        image: p.image && p.image.startsWith('data:') ? 'https://picsum.photos/id/48/400/300' : p.image
      }));
    }

    const payload = JSON.stringify({ user, products });
    return btoa(unescape(encodeURIComponent(payload)));
  } catch {
    return '';
  }
}

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('sa_token');
  const hydrate = buildHydrateHeader();
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
      ...(hydrate ? { 'x-sa-hydrate': hydrate } : {})
    }
  };
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache()
});

export default client;
